<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              placeholder="合同编号/名称/承运商/创建人/修改人搜索..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-allow="'actAdd'"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                openEditPage({
                  pageType: 'add'
                })
              "
            >
              <b-icon-plus></b-icon-plus>新增
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="openImportPage"
            >
              <b-icon-cursor></b-icon-cursor>导入
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" labelPosition="top">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="合同编号">
              <el-input
                v-model="form.contractCarrierNo"
                placeholder="请输入合同编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同名称">
              <el-input
                v-model="form.contractCarrierName"
                placeholder="请输入合同名称"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运输模式">
              <dict-select
                v-model="form.transportMode"
                placeholder="请选择运输模式"
                style="width: 100%"
                default
                filterable
                clearable
                :body="transportModeDictParams"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计费单位">
              <dict-select
                v-model="form.chargeUnit"
                placeholder="请选择计费单位"
                style="width: 100%"
                default
                filterable
                clearable
                :body="chargeUnitDictParams"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结算方式">
              <dict-select
                v-model="form.settlementMethod"
                placeholder="请选择结算方式"
                style="width: 100%"
                default
                filterable
                clearable
                :body="settlementMethodDictParams"
              >
              </dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="组织机构">
              <org-cascader
                filterable
                :lastValue.sync="form.orgCode"
                :valueString.sync="form.orgCodeList"
                :props="{ multiple: false }"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="甲方签署人">
              <el-input
                v-model="form.signCustPerson"
                placeholder="请输入甲方签署人"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="乙方签署人">
              <el-input
                v-model="form.signOrgPerson"
                placeholder="请输入乙方签署人"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="6">
            <el-form-item label="合同保管人">
              <el-input
                v-model="form.contractCarrierManagePerson"
                placeholder="请输入合同保管人"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="创建人名字">
              <el-input
                v-model="form.createByName"
                placeholder="请输入创建人名字"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="修改人名字">
              <el-input
                v-model="form.modifyByName"
                placeholder="请输入修改人名字"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可用状态">
              <el-checkbox-group v-model="form.contractCarrierStatusList">
                <el-checkbox label="Y">已审核</el-checkbox>
                <el-checkbox label="N">新增</el-checkbox>
                <el-checkbox label="D">删除</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同开始日期">
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.startBeginDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择开始日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.startEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择开始日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期">
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endBeginDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择结束日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择结束日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="创建时间">
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createBeginDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择创建时间"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择创建时间"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间">
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyBeginDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择修改时间"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择修改时间"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  contractCarrierStatusList: ['Y', 'N']
}
export default {
  data() {
    return {
      chargeUnitDictParams: { type: 'chargeUnit' },
      transportModeDictParams: { type: 'transportMode' },
      settlementMethodDictParams: { type: 'settlementMethod' },
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 普通查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 打开编辑页面
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'contract-carrierContract-detail',
        params: { ...params, pageType }
      })
    },
    //打开导入页面
    openImportPage(){
      this.$router.push({
        name: 'contract-carrierContract-import',
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
